
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/podscribe",
      function () {
        return require("private-next-pages/destinations/podscribe.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/podscribe"])
      });
    }
  